import WordInsideManageSort from "@/pages/comp/plan/word/word_inside_sort/common/manage_sort";

function WordInsideSortManagePopup(props: any) {
  let myProps = {
    listOpt: {},
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    ...props
  };

  return (
    <div>
      <WordInsideManageSort
        listOpt={myProps.listOpt}
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
      ></WordInsideManageSort>
    </div>
  );
};
export default WordInsideSortManagePopup;